import { Injectable } from "@angular/core";
import { LocalStorageOperationsService } from "@ehrCore/services/local-storage-operations/local-storage-operations.service";
import { ELocalStorageKeys } from "@ehrSharedResources/enums/localStorageKeys.enum";
import { ILocalStorageReadUserDetailsValues, ILocalStorageUserDetailsValues } from "@ehrSharedResources/models/local-stoage-values.model";
import { IScrapedData } from "@ehrSharedResources/models/scraped-data.model";
import { convertToCamelCase } from "@ehrSharedResources/utils/utils";

@Injectable({
  providedIn: "root"
})
export class LocalStorageHandlerService {
  /**
   * Service to handle local storage operations related to extension.
   * It provides methods to set and get extension related values in local storage.
   */
  constructor(private localStorageOperations: LocalStorageOperationsService) { }

  setScrapedDataValue(value: IScrapedData): void {
    this.localStorageOperations.set(ELocalStorageKeys.ScrapedData, JSON.stringify(value));
  }

  setUserDetailsValue(value: ILocalStorageUserDetailsValues): void {
    this.localStorageOperations.set(ELocalStorageKeys.UserDetails, JSON.stringify(
      convertToCamelCase<ILocalStorageUserDetailsValues>(value)
    ));
  }

  setMemberMap(athenaPatientId: number, memberId: number): void {
    const memberMapString = this.localStorageOperations.get(ELocalStorageKeys.EvaireAthenaMemberMap);
    const memberMap = memberMapString ? JSON.parse(memberMapString) : {};
    memberMap[athenaPatientId] = memberId;
    this.localStorageOperations.set(ELocalStorageKeys.EvaireAthenaMemberMap, JSON.stringify(memberMap));
  }

  private _getMemberMap(): Record<number, string> {
    const memberMap = this.localStorageOperations.get(ELocalStorageKeys.EvaireAthenaMemberMap);
    return memberMap ? JSON.parse(memberMap) : {};
  }

  getCachedEvaireMemberPk(athenaPatientId: number): number {
    const memberMap = this._getMemberMap();
    return memberMap[athenaPatientId] ? Number(memberMap[athenaPatientId]) : null;
  }

  getUserDetailsValue(): string {
    return this.localStorageOperations.get(ELocalStorageKeys.UserDetails);
  }

  getUserDetails(): ILocalStorageReadUserDetailsValues | null {
    const userDetailsString = this.localStorageOperations.get(ELocalStorageKeys.UserDetails);
    if (!userDetailsString) {
      return null;
    }
    return JSON.parse(userDetailsString);
  }

  getScrapedDataValue(): IScrapedData {
    const scrapedData = this.localStorageOperations.get(ELocalStorageKeys.ScrapedData);
    return scrapedData ? JSON.parse(scrapedData) : null;
  }

  clearAllValues(): void {
    this.localStorageOperations.remove(ELocalStorageKeys.UserDetails);
    this.localStorageOperations.remove(ELocalStorageKeys.ScrapedData);
  }


  setAuthenticatedFlag(value: 0 | 1): void {
    this.localStorageOperations.set(ELocalStorageKeys.Authenticated, JSON.stringify(value));
  }

  getAuthenticatedFlag(): number {
    const authenticatedFlag = this.localStorageOperations.get(ELocalStorageKeys.Authenticated);
    return authenticatedFlag && Number(authenticatedFlag);
  }
}
